import { types } from "../types/types";

export const saveCategoriesToChart = (categoriesToChart) => ({
    type: types.saveCategoriesToChart,
    payload: categoriesToChart,
  });

  export const clearCategoriesToChart = () => ({
    type: types.clearCategoriesToChart,
  });